"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.NftPromoTokenNotificationMetadataToJSON = exports.NftPromoTokenNotificationMetadataFromJSONTyped = exports.NftPromoTokenNotificationMetadataFromJSON = void 0;
var _1 = require("./");
function NftPromoTokenNotificationMetadataFromJSON(json) {
    return NftPromoTokenNotificationMetadataFromJSONTyped(json, false);
}
exports.NftPromoTokenNotificationMetadataFromJSON = NftPromoTokenNotificationMetadataFromJSON;
function NftPromoTokenNotificationMetadataFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'promoTokenId': json['promoTokenId'],
        'notificationType': (0, _1.NotificationTypeFromJSON)(json['notificationType']),
    };
}
exports.NftPromoTokenNotificationMetadataFromJSONTyped = NftPromoTokenNotificationMetadataFromJSONTyped;
function NftPromoTokenNotificationMetadataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'promoTokenId': value.promoTokenId,
        'notificationType': (0, _1.NotificationTypeToJSON)(value.notificationType),
    };
}
exports.NftPromoTokenNotificationMetadataToJSON = NftPromoTokenNotificationMetadataToJSON;
